// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"23":"1ea54295b4fdafed873e","2826":"76876beef211ed992c4d","6436":"f40e1b84e3eae272c87a","8965":"8f8fccc0da8253951c93","9815":"713cc471e6ff3818b671"}[chunkId] + ".js";
};